"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateLocalityAssignDelete = void 0;
const client_1 = require("@apollo/client");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const localityAssignDeleteMutation = (0, client_1.gql) `
  mutation LocalityAssignDelete($workspaceId: ID!, $localityId: ID!, $userId: ID!) {
  localityAssignDelete(workspace: $workspaceId, locality: $localityId, user: $userId) {
    id
  }
}`;
const mutateLocalityAssignDelete = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(localityAssignDeleteMutation, { variables });
    (0, error_handler_1.processErrors)(errors);
    return data?.localityAssignDelete;
};
exports.mutateLocalityAssignDelete = mutateLocalityAssignDelete;
